export default __webpack_public_path__ + "media/images/icons_fc/flow-c7d64eb9d92a3fcbf4e0f323b1fd5d46.png";